import { AppInstallationSubscription } from 'hooks/shopify/queries/get-all-app-subscriptions.graphql';
import { useAppSelector } from 'redux/hooks';
import {
    selectShopifyCurrentSubscription,
    selectShopifySubscriptionFetching,
} from 'redux/slices/shopify-app-pricing/shopify-app-pricing.selector';

interface ShopifySubscription {
    currentSubscription: AppInstallationSubscription | undefined;
    isLoading: boolean;
}

const useShopifySubscription = (): ShopifySubscription => {
    const currentSubscription = useAppSelector(selectShopifyCurrentSubscription);
    const isLoading = useAppSelector(selectShopifySubscriptionFetching);

    return { currentSubscription, isLoading };
};

export default useShopifySubscription;
